// Components==============
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { DreamModalContext } from '../DreamModal';
import { DreamModalItemContext } from '../DreamModalItem';
import './ProgressManager.module.scss';
// =========================

export default function ProgressManager({
  trainingIsFinished,
}: {
  trainingIsFinished?: boolean;
}) {
  const { amount, id, type, done, contribution } = useContext(
    DreamModalItemContext
  );
  const { originState, editing, setEditState } = useContext(DreamModalContext);

  if (!id) return <></>;

  const isTraining = typeof trainingIsFinished === 'boolean';

  function handleChangeAmount(
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    dir: 'min' | 'plus'
  ) {
    e.stopPropagation();

    const calcNewAmount = (nr: number) =>
      nr === 1 && dir === 'min' ? 1 : dir === 'min' ? nr - 1 : nr + 1;

    if (type === 'App\\Activity' || type === 'App\\Training')
      setEditState((prev) => ({
        ...prev,
        activities: prev.activities.map((a) =>
          a.id === id && a.type === type
            ? { ...a, amount: calcNewAmount(a.amount) }
            : a
        ),
      }));

    if (type === 'App\\Skill')
      setEditState((prev) => ({
        ...prev,
        skills: prev.skills.map((s) =>
          s.id === id ? { ...s, amount: calcNewAmount(s.amount) } : s
        ),
      }));
  }

  return (
    <div
      styleName={`${
        type === 'App\\Activity'
          ? 'activity'
          : type === 'App\\Training'
          ? 'training'
          : 'skill'
      } wrapper`}
    >
      {!!trainingIsFinished && originState === 'view' && !editing && (
        <div styleName="training-finished ">
          <FontAwesomeIcon icon={faCheck} />
        </div>
      )}
      {!isTraining && (
        <>
          {editing ? (
            <div styleName="editing">
              <div onClick={(e) => handleChangeAmount(e, 'min')}>
                <FontAwesomeIcon icon={faMinus} />
              </div>
              {amount}
              <div onClick={(e) => handleChangeAmount(e, 'plus')}>
                <FontAwesomeIcon icon={faPlus} />
              </div>
            </div>
          ) : !amount ? (
            <></>
          ) : contribution ? (
            <div styleName="inactive">{amount}</div>
          ) : originState === 'view' ? (
            <div styleName={`viewing ${done && done >= amount ? 'done' : ''}`}>
              {done || 0} / {amount}
            </div>
          ) : (
            <div styleName="inactive">{amount}</div>
          )}
        </>
      )}
    </div>
  );
}
